/**
 * @flow
 * */
import { takeLatest } from 'redux-saga/effects';

import ACTIONS from 'modules/LCRMT/Alerts/store/actions/alerts/hourlyAlertsActions/types';
import alertsSDK from '../sdk/AlertsSDK';

class HourlyAlertsController {
  static* cancelHourlyAlertSDKCalls({ payload }) {
    const { name } = payload;
    yield alertsSDK.cancelAlertSDKCalls({ name });
  }

  static* actionsWatcher(): Object {
    yield takeLatest(ACTIONS.CANCEL_HOURLY_ALERT_SDK_CALL, HourlyAlertsController.cancelHourlyAlertSDKCalls);
  }
}

export default HourlyAlertsController.actionsWatcher;
